import { Home as HomeFeature } from '../../../features/home/home';

const Home = () => {
  return <HomeFeature />;
};

export { Home };
